import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useExpenseActions() {
  const [isLoading, setLoading] = useState(false);

  const pay = useCallback((expenseId) => {
    setLoading(true);
    return quarkusApi
      .post(`/financial/expenses/${expenseId}`, null, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const remove = useCallback((expenseId) => {
    setLoading(true);
    return quarkusApi
      .delete(`/financial/expenses/${expenseId}`, authHeader())
      .finally(() => setLoading(false));
  }, []);

  return { pay, remove, isLoading };
}
